// @ts-nocheck
import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Scale, Calendar, Users, Wallet } from 'lucide-react'

// Os 5 principais pedidos pelo cliente: Dashboard, Processos, Agenda, Clientes, Financeiro.
const links = [
  { to: '/pwa/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/pwa/cases',     icon: Scale,           label: 'Processos' },
  { to: '/pwa/agenda',    icon: Calendar,        label: 'Agenda' },
  { to: '/pwa/clients',   icon: Users,           label: 'Clientes' },
  { to: '/pwa/financial', icon: Wallet,          label: 'Financeiro' },
]

export const BottomNav = () => {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 border-t border-[#c4ab83]/25 bg-white/95 backdrop-blur-md flex z-50 shadow-[0_-6px_24px_-18px_rgba(15,23,42,0.35)]"
      style={{
        height: 'calc(64px + env(safe-area-inset-bottom))',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {links.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors ${
              isActive ? 'text-[#a88a5c]' : 'text-slate-400 hover:text-slate-700'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <div
                className={`p-1.5 rounded-xl transition-all ${
                  isActive ? 'bg-[#c4ab83]/15' : ''
                }`}
              >
                <Icon className="h-5 w-5" strokeWidth={isActive ? 2.2 : 1.8} />
              </div>
              <span className="leading-none">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
